<header class="admin-page-header">
  <div class="admin-page-header__text">
    <h1>{{ title }}</h1>
    <p *ngIf="subtitle">{{ subtitle }}</p>
  </div>

  <div class="admin-page-header__actions">
    <ng-content select="[header-actions]"></ng-content>
  </div>
</header>
